import { render } from "./ShareMessage.vue?vue&type=template&id=47b4a1a7&scoped=true"
import script from "./ShareMessage.vue?vue&type=script&lang=js"
export * from "./ShareMessage.vue?vue&type=script&lang=js"

import "./ShareMessage.vue?vue&type=style&index=0&id=47b4a1a7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b4a1a7"]])

export default __exports__